import CrudBase from '../../../CrudBase';
import axios from '../../../../axios-common';

class CollectionApi extends CrudBase {

  getCollection = (date, params) => axios.get(`${this.endpoint}/get-by?date=${date}`, params);

  defaultMethods = {
    getCollection: this.getCollection,
  }
};

const collection = new CollectionApi('api/v1/collection');

export default collection.defaultMethods;
